import React, { Component } from "react";
import styled from "styled-components";
import { withPage } from "../../Page";
import { StaticFluidImage } from "../../Components/StaticImage/";
import IntroSection from "../../Components/IntroSection";
import PartSection from "../../Components/PartSection";

class PrivacyPolicyPage extends Component {
  render() {
    return (
      <Wrapper>
        <div className="banner">
          <StaticFluidImage
            path="banner06.jpg"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 2
            }}
          />
          <h3>- Privacy Policy -</h3>
        </div>
        <div className="container">
          <Content>
            {`會員隱私權保護\n\n1. 對於會員所登錄或留存之個人資料，本網站同意在未依法律規定或是獲得會員同意時，不對外揭露會員之姓名、地址、電子郵件、地址及其他依法受保護之個人資料，但是在下列的情況下，本公司有可能會查看或提供會員的個人資料或相關電信資料給相關政府機關、或主張其權利受侵害並提出適當證明之第三人：\n- 依法令規定、或依司法機關或其他相關政府機關的命令、或其他有權機關基於法定程序之要求。\n- 會員涉及違反法令、侵害第三人權益、或違反本使用條款或各該使用規範或約定。\n- 為保護會員服務系統之安全或經營者之合法權益。\n- 為保護其他使用者或其他第三人的合法權益。\n- 為維護本系統的正常運作。\n\n2.對於會員所登錄或留存之個人資料，會員同意本網站及關係企業或合作對象，得於合理之範圍內蒐集、處理、保存、傳遞及利用該等資料，以提供使用者行銷、其他資訊或服務、或作成會員統計資料、或進行關於網路行為之調查或研究，或為任何之合法使用，或提供其他服務。\n\n3.因使用本服務所提供之網路活動，可能須透過宅配或貨運業者始能完成貨品（或贈品等）之配送或取回，因此，會員同意並授權本網站得視該次網路活動之需求及目的，將由會員所提供且為配送所必要之個人資料（如收件人姓名、配送地址、連絡電話等），提供予宅配、貨運等運送業者及相關配合之廠商，以利完成該次貨品（或贈品等）之配送、取回。\n\n4.倘會員拒絕前述蒐集、處理、保存、傳遞及利用者，請以Email至服務信箱（service@hecafe.com.tw）告知本網站，經本網站進行身份確認後，本網站將依會員拒絕之請求進行相關處理。\n\n5.會員若表示無法透過網路請求本網站進行會員資料查詢、修改、刪除或相關變動之服務時，需提供詳細個人資料【即身份證字號（必要時需出示身分證影本圖片）、姓名、出生年月日、個人電話、手機、住址】以供查核會員身分，若會員拒絕提供前述任一項個人資料，本網站服務人員有權拒絕會員進行後續會員資料調整之請求。另為善盡本網站管理人之責及保障會員權益，本公司將保留會員請求上述服務時之相關紀錄及其內提供之所有個人資訊，當會員提供個人資料時，視同接受本公司留存其記錄之作業。\n\n6.本網站就會員的行為是否符合會員規範，有最終決定權。若本網站決定會員的行為違反本會員規範或任何法令，會員同意本網站得隨時停止帳號使用權或清除帳號，及停止使用本網站服務。會員在違反法律規定之情事，應自負法律責任。`}
          </Content>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  & > .banner {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 100%;
    height: 600px;
    background-color: lightgray;

    & > h3 {
      position: absolute;
      z-index: 3;
      letter-spacing: 20px;
      font-size: 54px;
      color: white;
    }

    @media screen and (max-width: 650px) {
      & > h3 {
        letter-spacing: 10px;
        font-size: 40px;
      }
    }

    @media screen and (max-width: 550px) {
      height: 300px;
      & > h3 {
        letter-spacing: 5px;
        font-size: 26px;
      }
    }
  }

  & > .container {
    margin: 0 auto;
    padding: 10px;
    max-width: 720px;
    width: 100%;
  }
`;

const Content = styled.div`
  padding: 70px 10px;
  white-space: pre-wrap;
  line-height: 40px;
  font-size: 14px;
  color: #353535;
`;

export default withPage(PrivacyPolicyPage);
